import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home mb-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "py-4" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Recuperar conta", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Enviaremos os dados por email para a recuperação de sua conta", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mt-5 text-center" }, " Caso venha a surgir algum problema ou dúvida, por favor entre em contato com a equipe de suporte via email suporte@email.com ", -1)

import AuthForm from "@/components/form/AuthForm.vue";
import LogoProject from "@/components/videntity/LogoProject.vue";
import ButtonsAuth from "@/components/form/ButtonsAuth.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'RetrieveAccount',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createVNode(AuthForm, {
      "is-logging": false,
      class: "mt-4"
    }, {
      default: _withCtx(() => [
        _createVNode(ButtonsAuth, { "is-logging": false }),
        _hoisted_5
      ]),
      _: 1
    })
  ]))
}
}

})